import { useFeatureFlagsQuery } from "@/hooks/useFeatureFlagsQuery";

/**
 * Booking-action kill-switches for the UI. Each value is TRUE when the action is ENABLED. Defaults
 * to false (disabled) while the flags query is loading or errored — the safe default, matching the
 * server's default-disabled stance. Backed by GET /settings/features (any authenticated user).
 */
export function useBookingActionFlags() {
  const { data } = useFeatureFlagsQuery();
  return {
    datetime: data?.changeBookingDateTimeEnabled ?? false,
    duration: data?.changeBookingDurationEnabled ?? false,
    room: data?.changeBookingRoomEnabled ?? false,
    upgradeToSlot: data?.upgradeToSlotEnabled ?? false,
  };
}
